
const useSelect = () => {
  const props = {
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    }
  }

  return {
    props
  }
}

export default useSelect
